import i18n from 'services/base/i18n';

export default {
  // Placeholder text for the search box
  placeholder: () => i18n.pgettext('Components|Search Devices', 'Search'),
};
